export enum AuthRole {
  // Static Roles
  Dash = 'dash',
  Foundation = 'foundation',
  Api = 'api',
  // Dynanic Roles
  FoundationMember = 'foundation-member',
  Owner = '$owner',
  Partner = 'partner'
}
